import { styled } from '@mui/material'
import doubleVerifyFlowSrc from 'assets/images/double-verify-flow.jpg'
import tripleVerifyFlowSrc from 'assets/images/triple-verify-flow.jpg'

const FlowTypeImg = styled('img')(({ theme }) => ({
  marginTop: theme.spacing(2),
  maxWidth: '60%',
  minWidth: 400,
}))

interface FlowGraphProps {
  type: string
}

export default function OperationFlowTypeGraph({ type }: FlowGraphProps) {
  if (type === 'doubleCheckVerify') {
    return <FlowTypeImg src={doubleVerifyFlowSrc} />
  }
  if (type === 'tripleCheckVerify') {
    return <FlowTypeImg src={tripleVerifyFlowSrc} />
  }
  return null
}
